import styled from "@emotion/styled"
import { Modal } from "@mui/material"
import { DonationMessages } from "app/[locale]/(layout)/donation-application-form/page"
import { useRouter } from "next/navigation"
import { useEffect, useState } from "react"
import { Desktop, FormSubmitSuccessIcon, Mobile, NewText, useIsDesktop } from "ui"
import { sharedColors } from "ui/theme/colors"

const StyledContainer = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: white;
  display: flex;
  padding: 40px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  z-index: 10;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  ${(props) => props.theme.breakpoints.up("md")} {
    position: relative;
    bottom: unset;
    border-radius: 0;
    padding-bottom: 160px;
  }
  &:focus {
    outline: none;
  }
`
const StyledButton = styled.button`
  background-color: white;
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  border-radius: 200px;
  border: 2px solid #000;
  outline: none;
  min-width: 121px;
  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    border: 2px solid #6f6f6f;
  }
`

function SuccessModal({ messages }: { messages: DonationMessages }) {
  const [open, setOpen] = useState(true)
  const isDesktop = useIsDesktop()
  const router = useRouter()
  useEffect(() => {
    window.scrollTo({
      top: isDesktop ? 320 : 0,
      behavior: "auto",
    })
    if (!isDesktop) {
      document.body.style.overflow = "hidden"
    }
    return () => {
      document.body.style.overflow = "auto"
    }
  }, [isDesktop])

  const handleButtonPress = () => {
    router.push("/esg")
  }
  const handleClose = () => {
    setOpen(false)
  }
  return (
    // <Button onClick={handleOpen}>Open modal</Button>
    <>
      <Mobile>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <StyledContainer>
            <FormSubmitSuccessIcon />
            <NewText
              desktopFontSize={32}
              desktopFontWeight="400"
              desktopLineHeight="36px"
              mobileFontSize={24}
              mobileFontWeight="400"
              mobileLineHeight={"28px"}
              component="h1"
              color={"black"}
            >
              {messages.donationSuccessTitle}
            </NewText>
            <NewText
              desktopFontSize={14}
              desktopFontWeight="400"
              desktopLineHeight="20px"
              mobileFontSize={12}
              mobileFontWeight="400"
              mobileLineHeight={"17px"}
              component="h1"
              color={"black"}
              style={{ maxWidth: isDesktop ? "403px" : "60%" }}
              textAlign="center"
            >
              {messages.donationSuccessDescription}
            </NewText>
            <StyledButton onClick={handleButtonPress}>
              <NewText
                component={"p"}
                desktopFontSize={16}
                mobileFontSize={14}
                desktopFontWeight={600}
                color={sharedColors.black}
              >
                {messages.donationSuccessButton}
              </NewText>
            </StyledButton>
          </StyledContainer>
        </Modal>
      </Mobile>
      <Desktop>
        <StyledContainer>
          <FormSubmitSuccessIcon />
          <NewText
            desktopFontSize={32}
            desktopFontWeight="400"
            desktopLineHeight="36px"
            mobileFontSize={24}
            mobileFontWeight="400"
            mobileLineHeight={"28px"}
            component="h1"
            color={"black"}
          >
            {messages.donationSuccessTitle}
          </NewText>
          <NewText
            desktopFontSize={14}
            desktopFontWeight="400"
            desktopLineHeight="20px"
            mobileFontSize={12}
            mobileFontWeight="400"
            mobileLineHeight={"17px"}
            component="h1"
            color={"black"}
            style={{ maxWidth: isDesktop ? "403px" : "60%" }}
            textAlign="center"
          >
            {messages.donationSuccessDescription}
          </NewText>
          <StyledButton onClick={handleButtonPress}>{messages.donationSuccessButton}</StyledButton>
        </StyledContainer>
      </Desktop>
    </>
  )
}

export default SuccessModal
